import React, { useEffect, useState } from "react";
import { RouterConstant } from "../../routers/index";
import ExerciseCard, { ExerciseCardProps } from "../../components/exercise-card";
import { useLayoutContext } from "../../layouts/general-layout";
import ChatHeader from "../../components/chat-header";
import { useNavigate } from "react-router-dom";
import { SubscriptionService, AvailableSubscription } from "../../services/subscription/subscription.service";
import { useUserStore } from "../../utils/userStore";
import Button from "../../components/button";
import { Loader, warningIcon } from "../../assets/images/index";
import "./choose-packages.scss";

export default function Index() {
    const { t } = useLayoutContext();
    const { ROUTERS_PATH } = RouterConstant;
    const navigate = useNavigate();
    const { userInfo, user_attributes, setUserInfo } = useUserStore();
    const subscriptionService = new SubscriptionService();

    const [packages, setPackages] = useState<AvailableSubscription[]>([]);
    const [selectedPackageId, setSelectedPackageId] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [hasActivePackage, setHasActivePackage] = useState(false);
    

    useEffect(() => {        
        if (userInfo?.userId) {
            fetchPackages();
        }
    }, [userInfo?.userId]);

    const fetchPackages = async () => {
        if (!userInfo?.userId) {
            setError(t("subscriptionCreationFailed"));
            return;
        }
        setLoading(true);
        try {
            const availablePackages = await subscriptionService.get_user_available_packages(userInfo.userId);            
            const activePackage = availablePackages.find(pkg => pkg.is_active_for_user);
            if (activePackage) {
                setHasActivePackage(true);
                return;
            }
            if (availablePackages.length === 0) return;
            setPackages(availablePackages);
            setSelectedPackageId(availablePackages[0].id);
        } catch (err: any) {
            console.error("Error fetching packages:", err);
            setError(t("subscriptionCreationFailed"));
        } finally {
            setLoading(false);
        }
    };

    const handlePackageSelect = (packageId: number) => {
        setSelectedPackageId(packageId);
        setError(null);
    };

    const handleNext = () => {
        if (!selectedPackageId) {
            setError(t("subscriptionCreationFailed"));
            return;
        }
        const selectedPackage = packages.find(pkg => pkg.id === selectedPackageId);
        navigate(ROUTERS_PATH.PAYMENT, { state: { selectedPackage } });
    };

    const handleBackClick = () => {        
        navigate(ROUTERS_PATH.CHOOSEEXERCISE);
    };

    


    const getCardColor = (index: number): "blue" | "green" | "purple" | "success" => {
        const colors: ("blue" | "green" | "purple" | "success")[] = ["blue", "green", "purple", "success"];
        return colors[index % colors.length];
    };

    const cardItems: ExerciseCardProps[] = packages.map((pkg, index) => ({
        title: pkg.display_name,
        description: pkg.description || "",
        buttonText: t("selectThisPackage"),
        color: getCardColor(index),
        price: pkg.price,
        onClick: () => handlePackageSelect(pkg.id),
    }));

    return (
        <div className="full-head-template choose-packages-page">
            <ChatHeader
                chatHeading={t("packagesPageTitle")}
                onBackClick={handleBackClick}
            />
            <>
                <div className="choose-packages-content">
                    <div className="choose-packages-header">
                        <h4>{t("choosePackageInstruction")}</h4>
                    </div>
                        {loading ? (
                            <div className="loaderBlock">
                                <img src={Loader} alt="Loader" />
                            </div>
                        ) : hasActivePackage || packages.length === 0 ? (
                            <div className="no-packages-message">
                                {t("youAlreadyHaveActiveSubscription")}
                            </div>
                        ) : (
                            <div className="exercise-cards">
                                {cardItems.map((item, index) => (
                                    <div
                                        key={packages[index].id}
                                        className={selectedPackageId === packages[index].id ? "package-card-selected" : ""}
                                        onClick={() => handlePackageSelect(packages[index].id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <ExerciseCard {...item} />
                                    </div>
                                ))}
                            </div>
                        )}


                </div>
                {error && (<div className="error-message"><img src={warningIcon} alt="" /> {error}</div>)}
                <div className="next-button-wrapper">
                    <Button
                        text={t("next")}
                        color="blue"
                        onClick={handleNext}                        
                        type="button"
                        disabled={!selectedPackageId}                        
                    />
                </div>
            </>
        </div>
    );
}